import { createEffect, on, useContext } from 'solid-js';
import { useLocation } from '@solidjs/router';
import { AppContext } from '../../app-context-provider/app-context-provider';

export const MAIN_CONTENT_ID = 'app';

/* WCAG 2.4.1 Bypass Blocks. Must be the first focusable element on the page.
   The href is the pre-hydration fallback; the click handler moves focus without
   changing the hash, which would otherwise trigger navigateToAnchor in page.tsx. */
export const SkipLink = () => {
    const { localize } = useContext(AppContext);
    const location = useLocation();

    let focusStartRef: HTMLSpanElement | undefined;

    /* Client-side navigation removes the activated link, leaving the Tab start point
       mid-page. Move it to just before the skip link, so the next Tab reaches the
       skip link as it does after a full page load. */
    createEffect(
        on(
            () => location.pathname,
            () => focusStartRef?.focus({ preventScroll: true }),
            { defer: true }
        )
    );

    const onClick = (event: MouseEvent) => {
        const main = document.getElementById(MAIN_CONTENT_ID);
        if (!main) return;

        event.preventDefault();
        main.focus();
    };

    return (
        <>
            <span ref={focusStartRef} tabindex="-1" class="outline-none" />
            <a
                href={`#${MAIN_CONTENT_ID}`}
                onClick={onClick}
                class="sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:top-cvi-4 focus-visible:left-cvi-4 focus-visible:z-[1002] focus-visible:px-cvi-5 focus-visible:py-cvi-3 rounded-cvi-round bg-cvi-fg-brand text-cvi-fg-on-color label-md font-cvi-medium focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 focus-visible:ring-cvi-focus-default focus-visible:ring-offset-cvi-bg-body print:hidden"
            >
                {localize('skip-to-main-content', 'Skip to main content')}
            </a>
        </>
    );
};
